










import { Component, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { TagType } from 'element-ui/types/tag'

@Component
export default class TcwPopupTag extends Mixins(BaseComponent) {
  @Prop({ default: '' })
  private title!: string
  @Prop({ default: '' })
  private content!: string
  @Prop({ default: 'small' })
  private size!: string
  @Prop({ default: 'primary' })
  private type!: TagType
  @Prop({ default: '' })
  private iconClass!: string
  @Prop({ default: '' })
  private text!: string

  private lockMessageOpen = false

  protected get isMobile(): boolean {
    return this.$mq === 'sp'
  }

  private get tagStyle(): { [key: string]: string } {
    const tagStyle: { [key: string]: string } = {}
    if (this.isMobile) {
      tagStyle['margin-right'] = '0'
      tagStyle['border-radius'] = '0'
    } else {
      tagStyle['margin-right'] = '0.5rem'
    }
    return tagStyle
  }
}
